import { useRejectTransferInstruction } from '@hooks/mutations/registry/transferInstruction/useRejectTransferInstruction';
import { useWithdrawTransferInstruction } from '@hooks/mutations/registry/transferInstruction/useWithdrawTransferInstruction';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { ContractId } from '@daml/types';
import { ChoiceDialogProps } from '../../../components/ChoiceDialog';
import { RejectDialog } from '../../../components/Dialog/RejectDialog';
import { useParties } from '../../../contexts/PartiesContext';
import { useAcceptTransferInstruction } from '../../../hooks/mutations/registry/transferInstruction/useAcceptTransferInstruction';
import { Row } from './types';

export const useCreateTransferActions = (onClose: () => void, r?: Row) => {
  const acceptTransferInstruction = useAcceptTransferInstruction();
  const withdrawTransferInstruction = useWithdrawTransferInstruction();
  const rejectTransferInstruction = useRejectTransferInstruction();
  const { party } = useParties();

  const onAcceptTransferInstruction = async () => {
    if (!r) {
      throw new Error('No row');
    }
    await acceptTransferInstruction({
      registrar: r.payload.registrar,
      transferCid: r.contractId as ContractId<TransferInstruction>,
    });
    onClose();
  };

  const onWithdrawTransferInstruction = async () => {
    if (!r) {
      throw new Error('No row');
    }
    await withdrawTransferInstruction({
      registrar: r.payload.registrar,
      transferCid: r.contractId as ContractId<TransferInstruction>,
    });
    onClose();
  };

  const onRejectTransferInstruction = async (reason: string) => {
    if (!r) {
      throw new Error('No row');
    }
    await rejectTransferInstruction({
      registrar: r.payload.registrar,
      transferCid: r.contractId as ContractId<TransferInstruction>,
      reason,
    });
    onClose();
  };

  const actions: ChoiceDialogProps['actions'] = [];
  if (!r) {
    return actions;
  }

  const isReceiver = r.payload.receiver === party;

  const isSender = r.payload.sender === party;

  if (r.state === 'Offered2step') {
    if (isReceiver) {
      actions.push(
        {
          name: 'Accept',
          action: onAcceptTransferInstruction,
        },
        {
          name: 'Reject',
          color: 'error',
          form: (
            <RejectDialog
              open
              disableDialog
              onClose={onClose}
              onReject={(reason: string) => onRejectTransferInstruction(reason)}
            />
          ),
        },
      );
    }
    if (isSender) {
      actions.push({
        name: 'Withdraw',
        action: onWithdrawTransferInstruction,
      });
    }
  }

  return actions;
};
